export default ({ app }) => {
  app.router.afterEach((to, from) => {
    if (process.client && to.path !== from.path) {
      document.body.setAttribute("tabindex", "-1");
      document.body.focus();
      document.body.removeAttribute("tabindex");
    }
  });
};
